import { FC, useEffect } from 'react';
import ReplacementRow from '../ReplacementRow';
import CartListItem from '../CartListItem';
import { OOSChooseSubstitutesDrawer } from '../OOSChooseSubstitutesDrawer';
import { OOSSelectSubstitutesDrawer } from '../OOSSelectSubstitutesDrawer/index';
import { CartListItemVariant } from '../CartListItem/CartListItem.style';
import useOOSCartList from 'pages/NewCart/hooks/useOOSCartList';
import { INewCartEntry } from 'pages/NewCart/ICart';

const OOSCartList: FC<{
  shipmentType: string;
  oosEntries: INewCartEntry[];
}> = ({ shipmentType, oosEntries }) => {
  const {
    isChooseSubstitutesDrawerOpen,
    substitutesShipment,
    isSelectSubstitutesDrawerOpen,
    closeChooseSubstitutesDrawer,
    closeSelectSubstitutesDrawer,
    shipmentReplaceOnClick,
    onContinueAfterSelectingProducts,
    refreshSubstitutes,
  } = useOOSCartList({
    shipmentType,
  });

  useEffect(() => {
    refreshSubstitutes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oosEntries.length]);

  return (
    <>
      {!!(substitutesShipment && oosEntries.length) ? (
        <>
          {/* OOS product which are having substitutes */}

          {substitutesShipment &&
            substitutesShipment.eligibleItems &&
            substitutesShipment.eligibleItems.length && (
              <>
                <ReplacementRow
                  forReplacementFound
                  substitutesShipment={substitutesShipment}
                  replaceBtnClickHandler={shipmentReplaceOnClick}
                />
                {substitutesShipment.eligibleItems.map(({ originalProduct: entry }) => (
                  <CartListItem
                    entry={entry}
                    shipmentType={shipmentType}
                    key={entry.entryNumber}
                    isLoading={false}
                    variant={CartListItemVariant.OOS}
                  />
                ))}
              </>
            )}

          {/* OOS product which are not having substitutes */}

          {substitutesShipment &&
            substitutesShipment.nonEligibleItems &&
            substitutesShipment.nonEligibleItems.length && (
              <>
                <ReplacementRow
                  forReplacementFound={false}
                  substitutesShipment={substitutesShipment}
                />
                {substitutesShipment.nonEligibleItems.map(entry => (
                  <CartListItem
                    entry={entry}
                    shipmentType={shipmentType}
                    key={entry.entryNumber}
                    isLoading={false}
                    variant={CartListItemVariant.OOS}
                  />
                ))}
              </>
            )}
        </>
      ) : (
        oosEntries.map(entry => (
          <CartListItem
            entry={entry}
            shipmentType={shipmentType}
            key={entry.entryNumber}
            isLoading={false}
            variant={CartListItemVariant.OOS}
          />
        ))
      )}

      {isChooseSubstitutesDrawerOpen && (
        <OOSChooseSubstitutesDrawer
          isOpen={isChooseSubstitutesDrawerOpen}
          shipmentType={shipmentType}
          close={closeChooseSubstitutesDrawer}
          substitutesShipment={substitutesShipment}
        />
      )}

      {isSelectSubstitutesDrawerOpen && (
        <OOSSelectSubstitutesDrawer
          isOpen={isSelectSubstitutesDrawerOpen}
          shipmentType={shipmentType}
          close={closeSelectSubstitutesDrawer}
          onContinue={onContinueAfterSelectingProducts}
          substitutesShipment={substitutesShipment}
        />
      )}
    </>
  );
};

export default OOSCartList;
